export enum Actions {
  DIALOG_OPEN = 'DIALOG_OPEN',
  DIALOG_CLOSE = 'DIALOG_CLOSE',
  SEARCH_FILTER = 'SEARCH_FILTER',
}
